import { Paper, Typography } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { KeyboardArrowRightRounded } from '@material-ui/icons';
import {
  Link as RRLink,
  Redirect,
  Route,
  Switch,
  useRouteMatch
} from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import PrivateRoute from '../../components/PrivateRoute';
import { getMasterData, getMasterDataRoute } from '../../constants/masterData';
import Breadcrumb from '../Breadcrumb';

export default function MasterData() {
  let { path } = useRouteMatch();
  const { t } = useTranslation();

  return (
    <Switch>
      {getMasterDataRoute(t).map(({ url, component }, index) => {
        return (
          <PrivateRoute
            key={index}
            exact
            path={`${path}${url}`}
            component={component}
          />
        );
      })}
      <PrivateRoute exact path={path} component={MasterDataHome} />
      <Route exact path="*" component={() => <Redirect to={path} />} />
    </Switch>
  );
}

function MasterDataHome() {
  const classes = useStyles();
  let { path } = useRouteMatch();
  const { t } = useTranslation();

  return (
    <div className={classes.root}>
      <Breadcrumb name="masterData" />
      <Typography className={classes.title} component="p" variant="h4">
        {t('masterData.title')}
      </Typography>
      {getMasterData(t).map(({ text, url }, index) => {
        return (
          <Paper className={classes.paper} key={index}>
            <RRLink className={classes.box} to={`${path}${url}`}>
              <Typography className={classes.flexGrow}>{text}</Typography>
              <KeyboardArrowRightRounded color="action" />
            </RRLink>
          </Paper>
        );
      })}
    </div>
  );
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      margin: theme.spacing(1.5, 0, 12, 0)
    },
    title: {
      margin: theme.spacing(1.5, 0, 2, 0),
      [theme.breakpoints.down('xs')]: {
        textAlign: 'center',
        margin: theme.spacing(3.5, 0, 4, 0)
      }
    },
    paper: {
      display: 'flex',
      border: '2px solid',
      borderColor: theme.palette.background.paper,
      borderRadius: '16px',
      transition: '0.4s',
      '&:hover, &.Mui-focusVisible': {
        borderColor: theme.palette.primary.main
      },
      marginBottom: theme.spacing(1.5),
      '&:last-child': {
        marginBottom: 0
      }
    },
    box: {
      display: 'flex',
      alignItems: 'center',
      flexGrow: 1,
      textDecoration: 'none',
      color: theme.palette.text.primary,
      padding: theme.spacing(1, 1.5)
    },
    flexGrow: {
      flexGrow: 1
    }
  })
);
